export default __webpack_public_path__ + "static/media/laundroLogo1.9e84bb4a.png";